'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Flag = require('./Flag');

var _Flag2 = _interopRequireDefault(_Flag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Flag2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/elements/Flag/index.js
 ** module id = 1661
 ** module chunks = 0
 **/